export default "__VITE_ASSET__CMYDwvYA__"